import React from "react";

// project image imports
import c2paLogo from "../../assetFiles/c2paLogo.png"
import cadenceLogo from "../../assetFiles/cadenceLogo.png"
import shooterLogo from "../../assetFiles/shooterLogo.png"
import blackjackLogo from "../../assetFiles/blackjackLogo.png"
import rpsLogo from "../../assetFiles/rpsLogo.png"
import pgLogo from "../../assetFiles/pgLogo.png"
import clockLogo from "../../assetFiles/clockLogo.png"
import scoreboardLogo from "../../assetFiles/scoreboardLogo.png"

// footer imports
import linkedinLogo from "../../assetFiles/LI-Logo.png"
import gmailLogo from "../../assetFiles/gmailLogo.png"
import githubLogo from "../../assetFiles/GitHub_Logo.png"

function ProjectsPage() {
    return (
        <div className="projects-page">
            <div style={{
                position: 'relative',
                top: '30px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '95%',   
                zIndex: 2,
                transition: 'opacity 1s ease-in',
            }}>
                <div style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    border: '2px solid #333',
                    borderRadius: '15px',
                    padding: '10px',
                    boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center'
                }}>
                    <a href="/Home" style={{ color: 'white', textDecoration: 'none' }}>Home</a>
                    <a href="/Education" style={{ color: 'white', textDecoration: 'none' }}>Education</a>
                    <a href="/Experience" style={{ color: 'white', textDecoration: 'none' }}>Experience</a>
                    <a href="/Leadership" style={{ color: 'white', textDecoration: 'none' }}>Leadership</a>
                    <a href="/Projects" style={{ color: 'white', textDecoration: 'none' }}>Projects</a>
                    <a href="/Skills" style={{ color: 'white', textDecoration: 'none' }}>Skills</a>
                </div>
            </div>
            <div>
                <h1 style={{color: 'white', marginTop: '80px'}}>Projects</h1>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            height: 'fit-content',
                            marginBottom: '2rem',
                            width: '43rem',
                        }}>
                    <h2 style={{color: 'white'}}>C2PA Authentication Tool (Application and Command Line)</h2>
                    <h3 style={{color: 'white'}}>OLIVER Agency Intern Project</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Languages: React.js, Python, Flask</span>
                    </div>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Software: Visual Studio Code, Google Cloud Services</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '550px', height: '200px', borderRadius: '15px'}}src={c2paLogo} alt="C2PA Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>Developed a web application prototype and command line tool for signing and authenticating AI-generated content, utilizing the official C2PA JavaScript and Python libraries.</li>
                                <li style={{marginBottom: '5px'}}>Hosted using Google Cloud services for internal use, and CLI tool was implemented into existing workflow tools, avaliable to hundreds of employees.</li>
                                <li style={{marginBottom: '5px'}}>Conducted primary research into C2PA implementation methods and current use in companies such as Adobe.</li>
                                <li style={{marginBottom: '5px'}}>Created, maintained, and updated prototype specifications, including wireframes, use cases, and limitations.</li>
                                <li>Currently creating video demonstrations, polishing for a high fidelity product, and a company presentation.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem',
                        }}>
                    <h2 style={{color: 'white'}}>Cadence of Cadencia</h2>
                    <h3 style={{color: 'white'}}>Game Design Class Final Project</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Language: C#</span>
                    </div>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Software: Unity</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '390px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={cadenceLogo} alt="Cadence Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>2-D RPG Rhythm Battle Game, think Pokemon, but instead of battles you beat a rhythm game level.</li>
                                <li style={{marginBottom: '5px'}}>Collaborated with a team of 4 and developed game in Unity, utilizing C# to implement immersive music and sounds, collisions between objects, and a rangefinder AI for enemies.</li>
                                <li style={{marginBottom: '5px'}}>Designed and implemented user interface and level design using Figma.</li>
                                <li>Currently sorting through permissions to show game demo, and will be avaliable here once granted.</li>
                            </ul>
                        </div>
                    </div>
                    <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px'}}></div>
                    <h2 style={{color: 'white'}}>Fixed Shooter (v1 and v2)</h2>
                    <h3 style={{color: 'white'}}>Game Design Class Prototype Projects</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Language: p5.js</span>
                    </div>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Software: p5.js Editor, Processing</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={shooterLogo} alt="Shooter Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>2-D Fixed Shooter Game, developed using p5.js as prototype projects for learning basic game design.</li>
                                <li style={{marginBottom: '5px'}}>Implemented spacebar as sole shooter button in version 1, and movement keys, sounds, and effects in version 2.</li>
                                <li style={{marginBottom: '5px'}}>Designed and implemented user interface and level design using Figma.</li>
                                <li>Check out version 1 <a style={{color:'white'}} href="https://stevenhuangtech.itch.io/prototype-1-pew-pew-shooter">here</a> and 
                                version 2 <a style={{color:'white'}} href="https://editor.p5js.org/huangs-nyc/sketches/89vAhELno">here!</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem',
                        }}>
                    <h2 style={{color: 'white'}}>Blackjack Web Application</h2>
                    <h3 style={{color: 'white'}}>Personal Project</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Languages: HTML, CSS, JavaScript</span>
                    </div>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Software: Visual Studio Code</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '400px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={blackjackLogo} alt="Blackjack Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>Developed a web application blackjack game using HTML, CSS, and JavaScript to implement different types of logic, 
                                including dealer logic, bust and blackjack logic, betting logic, and animated buttons.</li>
                                <li style={{marginBottom: '5px'}}>Developed visuals for both player and dealer tables.</li>
                                <li style={{marginBottom: '5px'}}>Utilized Figma to create user interface that was visually pleasing and to plan out button movements.</li>
                                <li style={{marginBottom: '5px'}}>Play it <a style={{color: 'white'}} href="https://blackjack-game-rho-flame.vercel.app/">here</a> or check out the GitHub repository{' '}
                                <a style={{color: 'white'}} href="https://github.com/huangs-nyc/blackjack-game">here!</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem',
                        }}>
                    <h2 style={{color: 'white'}}>Rock-Paper-Scissors Web Application</h2>
                    <h3 style={{color: 'white'}}>Personal Project</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Languages: HTML, CSS, JavaScript</span>
                    </div>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Software: Visual Studio Code</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={rpsLogo} alt="RPS Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>Developed a web application rock-paper-scissors game using HTML, CSS, and JavaScript to implement game logic and animated buttons.</li>
                                <li style={{marginBottom: '5px'}}>Developed visual logic for for play screen, and visuals for button images.</li>
                                <li style={{marginBottom: '5px'}}>Utilized Figma to create user interface that was visually pleasing and to plan out button movements.</li>
                                <li style={{marginBottom: '5px'}}>Play it <a style={{color: 'white'}} href="https://rock-paper-scissors-game-gray-seven.vercel.app/">here</a> or check out the GitHub repository{' '}
                                <a style={{color: 'white'}} href="https://github.com/huangs-nyc/rock-paper-scissors-game">here!</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem',
                        }}>
                    <h2 style={{color: 'white'}}>Random Password Generator Web Application</h2>
                    <h3 style={{color: 'white'}}>Personal Project</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Languages: HTML, CSS, JavaScript</span>
                    </div>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Software: Visual Studio Code</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={pgLogo} alt="PasswordGen Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>Developed a web application for a random password generator.</li>
                                <li style={{marginBottom: '5px'}}>Utilized Figma to create user interface that was visually pleasing and to plan out button movements.</li>
                                <li style={{marginBottom: '5px'}}>Play it <a style={{color: 'white'}} href="https://stevens-random-password-generator.vercel.app/">here</a> or check out the GitHub repository{' '}
                                <a style={{color: 'white'}} href="https://github.com/huangs-nyc/stevens-random-password-generator">here!</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem',
                        }}>
                    <h2 style={{color: 'white'}}>Analog Clock and Basketball Scoreboard Web Applications</h2>
                    <h3 style={{color: 'white'}}>Basic Personal Projects</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Languages: HTML, CSS, JavaScript</span>
                    </div>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>Software: Visual Studio Code</span>
                    </div>
                    <div style={{margin: '20px 0px',}}>
                        <img style={{width: '230px', height: '200px', borderRadius: '15px', border: 'solid 1px white', marginRight: '10px'}}src={clockLogo} alt="Clock Logo"></img>
                        <img style={{width: '380px', height: '200px', borderRadius: '15px', border: 'solid 3px white', marginLeft: '10px'}}src={scoreboardLogo} alt="Scoreboard Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>Developed web applications to learn basic HTML, CSS, and JavaScript.</li>
                                <li style={{marginBottom: '5px'}}>Utilized Figma and experimented locally to establish interface visuals.</li>
                                <li style={{marginBottom: '5px'}}>Check out the clock <a style={{color: 'white'}} href="https://analog-clock-ashen-five.vercel.app/">here</a> or check out the GitHub repository{' '}
                                <a style={{color: 'white'}} href="https://github.com/huangs-nyc/Analog-Clock">here!</a></li>
                                <li>Check out the scoreboard <a style={{color: 'white'}} href="https://basketball-scoreboard-app-alpha.vercel.app/">here</a> or check out the GitHub repository{' '}
                                <a style={{color: 'white'}} href="https://github.com/huangs-nyc/basketball-scoreboard-app">here!</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{
                        position: 'relative',
                        bottom: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '95%',
                        zIndex: 2,
                    }}>
                    <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                        <span style={{ color: 'white' }}>© 2024 Steven Huang | Product Manager & Developer | v1.2 | stevenhuangtech@gmail.com</span>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'  // This ensures vertical centering of the buttons
                            }}>
                            <span style={{ color: 'white'}}>Interested? Feel free to contact me! ---{'>'} </span>
                            <a 
                                href="mailto:stevenhuangtech@gmail.com" 
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '20px',
                                height: '20px',
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.7}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={gmailLogo}
                                    alt="Email"
                                    style={{
                                        width: '20px',
                                        height: '20px'
                                    }}
                                />
                            </a>
                            <a 
                                href="https://github.com/huangs-nyc" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '70px',
                                height: '20px'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={githubLogo} 
                                    alt="Github"
                                    style={{
                                    width: '50px',
                                    height: '20px'
                                    }}
                                />
                            </a>
                            <a 
                                href="https://www.linkedin.com/in/steven-huang-a60a8a22a/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100px',
                                height: '20px'
                            }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                            >
                            <img 
                                src={linkedinLogo} 
                                alt="LinkedIn"
                                style={{
                                width: '80px',
                                height: '20px'
                                }}
                            />
                            </a>
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default ProjectsPage